Ajax.Responders.register({
		onLoading: function() {
		document.body.addClassName('loading');
	},
		onComplete: function() {
		document.body.removeClassName('loading');
	}    
});

Shopify.onError = function(error) {
	alert('Error: ' + error.message);
}

Shopify.onCartUpdate = function(cart) {
	$('cart-total').innerHTML = Shopify.formatMoney(cart.total_price,"{{amount_with_comma_separator}}");
	$('cart-quantity').innerHTML = cart.item_count;
}  

Shopify.onItemAdded = function(line_item) { 
	Shopify.getCart(function(cart){
		Shopify.onCartUpdate(cart);
	});
}

var Showroom = {
	onVariantChange: function(select) {
		$('product-lightbox-price').update((select.options[select.selectedIndex]).title);
	},
	updatePrice: function(product_id) {
		var field = $('product-quantity-'+product_id);
		$('price-field-'+product_id).innerHTML = Shopify.formatMoney($('price-'+product_id).value * field.options[field.selectedIndex].text);
	}
}